import type { Input } from '@builder.io/sdk';

const twoColumnCardFields = [
  {
    name: 'cards',
    type: 'list',
    subFields: [
      {
        name: 'headingTag',
        type: 'string',
        enum: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
        defaultValue: 'h3',
        helperText: "Select the HTML tag for the card's heading",
      },
      {
        name: 'heading',
        type: 'string',
      },
      {
        name: 'body',
        type: 'richText',
      },
    ],
  },
] as const satisfies DeepReadonly<Input[]>;

const twoColumnCardConfig = {
  name: 'Two Column Card',
  inputs: twoColumnCardFields,
};

export type TwoColumnCardProps = GenerateBuilder<typeof twoColumnCardFields>;

export default twoColumnCardConfig;
